import React, { Component } from 'react'
import { object } from 'prop-types'
import acc from 'accounting'

import Subjects from './subjects'

class Curriculum extends Component {
  render () {
    const { header, subjects } = this.props
    console.log('subjects', subjects.toJS())
    console.log('header', header.toJS())

    return (
      <div className="curriculum-subjects">
        {subjects.get('data').map((d, k) => {
          return (
            <Subjects meta={d.get('meta')} subjects={d.get('subjects')} k={k} key={k} />
          )
        })}

        <table className="table">
          <thead>
            <tr className="info">
              <th colSpan="2"></th>
              <th className="text-right" colSpan="2">Total:</th>
              <th width="5%" className="text-right">{acc.formatNumber(subjects.get('meta').get('total_lec'), 1)}</th>
              <th width="5%" className="text-right">{acc.formatNumber(subjects.get('meta').get('total_lab'), 1)}</th>
              <th width="5%" className="text-right">{acc.formatNumber(subjects.get('meta').get('total'), 1)}</th>
              <th width="20%"></th>
            </tr>
          </thead>
        </table>
        <table className="signature" width="100%">
          <tbody>
            <tr>
              <td width="20%"></td>
              <td width="20%" className="line text-center">CHAIRMAN</td>
              <td width="20%"></td>
              <td width="20%" className="line text-center">DEAN</td>
              <td width="20%"></td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

Curriculum.propTypes = {
  header: object,
  subjects: object,
}

export default Curriculum



// WEBPACK FOOTER //
// ./src/containers/Print/Curriculums/curriculum.js